import Scrollbar from 'smooth-scrollbar';
import {$events} from '../../helpers/events';
import is from 'is_js';
import variables from '../../variables';
import {$dom} from '../../helpers/dom';
import {$style} from '../../helpers/style';
import {getScroll, preventDefault, sleep} from '../../helpers/_utilities';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import headerOnScroll from './headerOnScroll';
import buttonToUpOnScroll from './buttonToUpOnScroll';

gsap.registerPlugin(ScrollTrigger);

const {
	getAll,
	callAll,
	exist,
	attr
} = $dom;

export default function smoothScrollbar(
	outerOptions = {
		targets: 'js-smooth-scroll-target',
		toTopButton: variables.selectors.toTopButton.replace('.', '')
	}
) {
	let scrollbars = [];

	if (exist('.'+outerOptions.targets)) {

		const
			cl = cl => `.${cl}`,
			{mainScrollElementId} = variables.selectors,
			smoothScrollTargets = () => getAll(cl(outerOptions.targets))
		;

		function create(targets, options = {}) {

			if (is.touchDevice()) {
				headerOnScroll(getScroll().y);
				buttonToUpOnScroll(getScroll().y);
				$events
					.add('scroll', document, headerOnScroll)
					.add('scroll', document, buttonToUpOnScroll)
					.delegate
					.on('tap', cl(outerOptions.toTopButton), event => {
						preventDefault(event);

						window.scrollTo({
							top: 0,
							behavior: 'smooth'
						})
					})
			} else {
				const opts = Object.assign(variables.scrollbarDefaults, options);

				callAll(targets, target => {
					if (!Scrollbar.get(target)) {

						$style.set(target, 'height', '100%');

						let currentScrollBar = Scrollbar.init(target, opts);

						currentScrollBar.update();

						if (attr(target, 'id') === mainScrollElementId) {

							ScrollTrigger.scrollerProxy(target, {
								scrollTop(value) {
									if (arguments.length) currentScrollBar.scrollTop = value;
									return currentScrollBar.scrollTop
								}
							});
							currentScrollBar.addListener(ScrollTrigger.update);

							ScrollTrigger.defaults({ scroller: target });
							currentScrollBar.addListener(headerOnScroll);
						}

						scrollbars.push(currentScrollBar);
					}
				});

				$events.delegate.on('tap click', cl(outerOptions.toTopButton), event => {
					preventDefault(event);
					scrollbars.filter(scrollbar => {
						return attr(scrollbar.containerEl, 'id') === mainScrollElementId
					})[0].scrollTo(0, 0, variables.carouselDefaultDuration)
				});

				Scrollbar.detachStyle();
			}

			return scrollbars;
		}

		return {
			create,
			init() {
				return create(smoothScrollTargets())
			},
			destroy(targets = null) {
				if (is.not.null(targets)) {
					$events.delegate.off('scroll', document, headerOnScroll);

					$dom.callAll(targets, target => {
						$style.remove(target, 'height');

						let scrollbar = Scrollbar.get(target);

						if (Boolean(scrollbar)) {
							let index = scrollbars.indexOf(scrollbar);

							if (index >= 0) {
								scrollbars.splice(scrollbars.indexOf(scrollbar), 1);
								scrollbar.destroy();
							}
						}
					})
				} else {
					$style.remove(smoothScrollTargets(), 'height');
					Scrollbar.destroyAll();

					scrollbars = [];
				}

				return scrollbars

			},
			get list() {
				return scrollbars
			}
		}
	}
}
